import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MatomoTracker } from 'ngx-matomo';
import { DataService } from 'src/app/services/data.service';
import { SiteSettingService } from 'src/app/services/site-setting.service';
import { UtilService } from 'src/app/services/util.service';
import { AdminService } from '../../services/admin.service';
import { OfferDetailComponent } from '../offer-detail/offer-detail.component';

@Component({
  selector: 'app-offer-preview',
  templateUrl: '../offer-detail/offer-detail.component.html',
  styleUrls: ['../offer-detail/offer-detail.component.scss']
})
export class OfferPreviewComponent extends OfferDetailComponent {
  isPreview = true;

  constructor(
    protected dataService: DataService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected matomoTracker: MatomoTracker,
    public utilService: UtilService,
    public meta: Meta,
    public title: Title,
    private adminService: AdminService,
    protected siteSettingService: SiteSettingService
  ) {
    super(
      dataService,
      route,
      router,
      matomoTracker,
      utilService,
      meta,
      title,
      siteSettingService
    );
  }

  async fetchOffer(): Promise<void> {
    const uid = this.route.snapshot.paramMap.get('uid');
    this.offer = await this.adminService.getPreviewOfOffer(uid);
  }
}
